<template>
  <div>
    <vs-popup :title="$t('SelectSerials')" :active.sync="showModal">
      <vs-table :data="serialNumbers" ref="table" class="custom-tbl stripe">
        <template slot="thead">
          <vs-th style="width: 3%">#</vs-th>
          <vs-th style="width: 80%">{{ $t("SerialNumbers") }}</vs-th>
          <vs-th style="width: 17%">
            <div class="flex items-center gap-2">
              <span>{{ $t("Select") }}</span>
              <vs-checkbox
                @click="selectAllSerials($event)"
                :checked="isAllSerialsChecked" 
              >
              </vs-checkbox>
            </div>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td :data="data[indextr]">
              {{ parseInt(indextr) + 1 }}
            </vs-td>
            <vs-td>
              {{ data[indextr] }}
            </vs-td>
            <vs-td>
              <vs-checkbox
                @click="selectSerials($event, data[indextr], indextr)"
                :checked="selectedSerials.includes(data[indextr])"
              >
              </vs-checkbox>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-button
        type="filled"
        class="float-right mb-4 mt-4"
        @click.prevent="submitSerialForm"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}

.custom-tbl td {
  padding: 0.15rem 1rem !important;
}

.con-vs-checkbox {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
</style>

<script>
export default {
  name: "saleManagement_ReturnOrders_SerialPopup",
  props: {
    show: { default: false },
    serials: {
      default: {},
    },
    serialRowIndex: {
      default: {},
    },
    selectedSerials: {
      default: [],
    },
  },
  data() {
    return {
      serialNumbers: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
    isAllSerialsChecked: function () {
      if (this.serialNumbers.length == this.selectedSerials.length) {
        return true;
      }
      return false;
    },
  },
  methods: {
    submitSerialForm() {
      this.$emit("finish");
      this.$emit("clicked", this.selectedSerials, this.serialRowIndex);
    },
    selectSerials(event, val, index) {
      if (event.target.checked) {
        this.selectedSerials.push(val);
      } else {
        this.selectedSerials.splice(this.selectedSerials.indexOf(val), 1);
      }
    },
    selectAllSerials(event) {
      this.selectedSerials.splice(0, this.selectedSerials.length);
      if (event.target.checked) {
        for (let serial of this.serialNumbers) {
          this.selectedSerials.push(serial);
        }
      }
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.serialNumbers = JSON.parse(JSON.stringify(this.serials));
      }
    },
  },
};
</script>
